import { AddressPicker } from "@/components/pawkt/AddressPicker";
import { AlertTriangle } from "lucide-react";

const ADDR = ["pin", "state", "city", "area", "country"];

// Shown when a lead's NEW customer/pet would be missing mandatory details; nothing is saved until the booking succeeds.
export function NewPersonDetails({ missing, value, onChange }) {
  const needAddr = !!value.pin || missing.some((m) => m.entity === "customer" && ADDR.includes(m.field));
  const needDob = !!value.dob || missing.some((m) => m.field === "age");
  const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
  return (
    <div className="space-y-2 rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="lead-confirm-new-details">
      <p className="flex items-start gap-2 font-semibold"><AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" /> Add the required details to finish this booking</p>
      <p className="text-xs text-amber-700">Missing: {[...new Set(missing.map((m) => `${m.name} — ${m.label}`))].join("; ")}</p>
      {needAddr && <>
        <input value={value.address || ""} onChange={(e) => onChange({ address: e.target.value })} placeholder="House / street (optional)"
          className="h-9 w-full rounded-md border bg-white px-2 text-sm" data-testid="lead-confirm-address-line" />
        <AddressPicker value={value} onChange={onChange} testid="lead-confirm-addr" />
      </>}
      {needDob && <label className="block text-xs">Pet date of birth (approximate is fine) <span className="text-rose-600">*</span>
        <input type="date" max={today} value={value.dob || ""} onChange={(e) => onChange({ dob: e.target.value })}
          className="mt-1 h-9 w-full rounded-md border bg-white px-2 text-sm" data-testid="lead-confirm-pet-dob" /></label>}
    </div>
  );
}
